(() => {
  if (customElements.get('component-slider-swiper')) return;

  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.slider = this.querySelector('.swiper');
      if (!this.slider) return;

      this.buttonPrev = this.querySelector('.custom-prev-button');
      this.buttonNext = this.querySelector('.custom-next-button');
      this.pagination = this.querySelector('.custom-pagination');
      this.scrollbar = this.querySelector('.custom-scrollbar');

      this.initSlider();
    }

    disconnectedCallback() {
      const swiper = this.swiperInstance || this.slider?.swiper;
      swiper?.destroy?.(true, true);
      this.swiperInstance = null;
    }

    initSlider() {
      let inlineOptions = this.slider.dataset.options;
      if (inlineOptions) inlineOptions = JSON.parse(inlineOptions);

      const swiperParams = {
        slidesPerView: 1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        watchSlidesProgress: true,
        breakpoints: {
          480: {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev,
        },
        pagination: {
          el: this.pagination,
          clickable: true,
        },
        scrollbar: {
          el: this.scrollbar,
          draggable: true,
          hide: false,
        },
        ...inlineOptions,
      };

      this.swiperInstance = new Swiper(this.slider, swiperParams);
    }
  }

  customElements.define('component-slider-swiper', SwiperSlider);
})();
